export default {
  'pages.home': '首页',
  'pages.dashboard.title': '仪表盘',
  'pages.dashboard.analysis.title': '分析页',
  'pages.dashboard.monitor.title': '监控页',
  'pages.dashboard.workplace.title': '工作台',
  'pages.dashboard.welcome.title': '欢迎页',

  'pages.form.title': '表单页',

  'pages.list.title': '列表页',
  'pages.list.tablelist.title': '查询表格',
  'pages.list.basiclist.title': '标准列表',
  'pages.list.cardlist.title': '卡片列表',

  'pages.exception.title': '异常页',
  'pages.exception.403.title': '403',
  'pages.exception.404.title': '404',
  'pages.exception.500.title': '500',

  'pages.profile.title': '详情页',
  'pages.profile.basic.title': '基础详情页',
  'pages.profile.advanced.title': '高级详情页',

  'pages.result.title': '结果页',
  'pages.result.success.title': '成功页',
  'pages.result.fail.title': '失败页',

  'pages.account.title': '个人页',
  'pages.account.center.title': '个人中心',
  'pages.account.settings.title': '个人设置',
  'pages.account.settings.base.title': '基础设置',
  'pages.account.settings.security.title': '安全设置',
  'pages.account.settings.custom.title': '个性化',
  'pages.account.settings.binding.title': '账户绑定',
  'pages.account.settings.notification.title': '新消息通知',

  'pages.system.title': '系统管理',
  'pages.system.role-list.title': '角色管理',
  'pages.system.permission-list.title': '权限管理',

  'pages.settings.title': '设置',

  'pages.examples.title': '组件展示',
  'pages.examples.button.title': '按钮',
  'pages.examples.input.title': '输入框',
  'pages.examples.rate.title': '评分',
  'pages.examples.authority.title': '权限',

  'pages.nested.title': '路由嵌套',
  'pages.nested.menu1.title': 'Menu 1',
  'pages.nested.menu1-1.title': 'Menu 1-1',
  'pages.nested.menu1-2.title': 'Menu 1-2',
  'pages.nested.menu1-2-1.title': 'Menu 1-2-1',
  'pages.nested.menu2.title': 'Menu 2',
  'pages.nested.menu3.title': 'Menu 3',
  'pages.nested.menu3-1.title': 'Menu 3-1',

  'pages.jumpUrl.title': '跳转',
  'pages.jumpUrl.router.title': '路由',
  'pages.jumpUrl.github.title': '外链 Github',
};
